import ResultListTabContent from './ResultListTabContent';

export default ResultListTabContent;